<template>
    <div>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-12">
                        <h1 class="pad-top--xl pad-bottom--xl z-up text-white">
                            {{ userName }} - My Favourites
                        </h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-container">
            <div class="grid-x grid-padding-x border-bottom pad-top pad-bottom">
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-profile"
                        class="h4 text-light-grey">
                        My Profile
                    </router-link>
                </div>
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-orders"
                        class="h4 text-light-grey">
                        My Orders
                    </router-link>
                </div>
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-designs"
                        class="h4 text-light-grey">
                        My Designs
                    </router-link>
                </div>
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-favourites"
                        class="h4">
                        My Favourites
                    </router-link>
                </div>
            </div>

            <div class="clear grid-x grid-margin-x pad-top--large pad-bottom--large">
                <div
                    v-for="(garment, index) in garments"
                    v-bind:key="index"
                    class="cell small-6 medium-3 garment-card marg-bottom--small pad--xs relative">
                    <div>
                        <router-link
                            v-bind:to="`/${garment.category}/${garment.product_code}/${garment.name}`">
                            <div class="small-pad--small medium-pad--large">
                                <img
                                    v-bind:src="`https://our-catalogue.com/RUNS/images/${garment.product_code}.jpg?width=300`"
                                    alt="" />
                            </div>
                            <h5 class="text-blue" v-if="garment.featured_garment !== 'false'">
                                {{ garment.featured_garment }}
                            </h5>
                            <p class="small">
                                {{ garment.product_code }}<br />
                                {{ garment.name }}<br />
                                Price from:
                                <span class="text-light-blue">
                                    £{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*21)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}
                                </span>
                            </p>
                            <p class="add-to-basket">
                                <img
                                    width="55"
                                    src="../../../static/images/filter-garments/add-to-basket.png"
                                    alt="" />
                            </p>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '../../axios';

export default {
    name: 'MyFavourites',
    data() {
        return {
            garments: [],
        };
    },
    computed: {
        userName() {
            return this.$store.getters.userName;
        },
        authData() {
            return this.$store.getters.authData;
        },
    },
    methods: {
        getFavourites() {
            axios.get(`/Favourites/fetch.json?auth=${this.authData.token}&user=${this.authData.user}&cage=${this.authData.cage}`)
            .then((response) => {
                this.garments = response.data.garments;
            });
        },
    },
    mounted() {
        this.getFavourites();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/MyFavourites.vue